/** @format */

import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
	Component,
	Inject,
	Input,
	OnChanges,
	OnInit,
	PLATFORM_ID,
	SimpleChanges
} from '@angular/core';

import { take } from 'rxjs/operators';
import { BNPLScriptData, BNPLService } from './service/bnpl.service';
import { Environment, ProductSku, ProductStylePrices } from '@shared/data-access/interfaces';
import { WINDOW } from '@shared/utils/services';

@Component({
    selector: 'pdp-bnpl',
    template: `@if (displayBNPLMessage) {
		<div
			id="bnpl-messaging-container"
			class="hmf-mx-s hmf-mx-m-0 hmf-mb-m"></div>
	}`,
    standalone: false
})
export class BNPLComponent implements OnInit, OnChanges {
	@Input() isPayPalEligible: boolean;
	@Input() productPrice: ProductStylePrices;
	@Input() resolvedSku: ProductSku;

	public displayBNPLMessage: boolean;
	public BNPL_SCRIPT_SRC: string;

	constructor(
		private environment: Environment,
		@Inject(PLATFORM_ID) private platformId,
		private bnplService: BNPLService,
		@Inject(DOCUMENT) private document: Document,
		@Inject(WINDOW) protected window: Window
	) {}

	ngOnInit() {
		if (isPlatformBrowser(this.platformId)) {
			this.bnplService
				.getBNPLAssets$()
				.pipe(take(1))
				.subscribe(
					(bnplAssets) => {
						if (bnplAssets) {
							this.setBNPLScript(bnplAssets);
							this.displayBNPLMessage = true;
						} else {
							return (this.displayBNPLMessage = false);
						}
					},
					() => {
						this.displayBNPLMessage = false;
					}
				);
		} else {
			this.displayBNPLMessage = false;
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.isPayPalEligible =
			changes.resolvedSku?.currentValue?.isPayPalEligible || this.isPayPalEligible;

		if (
			isPlatformBrowser(this.platformId) &&
			changes.resolvedSku?.currentValue?.prices &&
			this.displayBNPLMessage
		) {
			this.offerMessaging(changes.resolvedSku.currentValue.prices.offerPrice, true);
		}
	}

	setBNPLScript(data: BNPLScriptData) {
		const bnplScript = document.createElement('script');
		bnplScript.src = this.environment.thirdParty.bnpl.scriptSrc;
		bnplScript.integrity = data['main.js'].integrity;
		bnplScript.crossOrigin = 'anonymous';
		bnplScript.async = true;
		bnplScript.type = 'text/javascript';
		this.document.head.appendChild(bnplScript);
		bnplScript.addEventListener('load', () => {
			this.offerMessaging(null, false);
		});
	}

	offerMessaging(newPrice: number | null, isRemount: boolean) {
		const elementId = 'bnpl-messaging-container';
		const productDetail = {
			minAmount: this.productPrice.minofferprice,
			maxAmount: this.productPrice.maxofferprice,
			amount: isRemount && newPrice ? newPrice : this.productPrice.minofferprice,
			isPaypalEligible: this.isPayPalEligible
		};
		if (this.window?.dsgbnpl !== undefined) {
			this.window.dsgbnpl.mountOfferMessages(elementId, productDetail);
		}
	}
}
